module.exports = __webpack_public_path__ + "35396eed7df7196dad5808bc7da3e2a3.ttf";